<template>
    <div class="choice-stripe-payment">
        <div id="choice">
            <button v-if="false" id="card" class="active">Carte de crédit</button>
          <button id="iban" class="active">Prélèvement SEPA</button>
        </div>
        <div v-if="false" id="stripe-card">
            <stripe-element
                ref="stripeElementCard"
                type="card"
                :stripe="stripeKey"
                @change="$emit('change-numbers',$event.complete,'card')">

                <div class="reduc-code" v-if="couponInput">
                    <label for="coupon-code">Code de réduction</label>
                    <div class="form-field coupon">
                        <input id="coupon-code" type="text" v-model="couponCode" name="coupon-code" />
                        <button @click="checkCoupon" :class="{'button--is-loading': couponCheckLoading}">Vérifier</button>
                    </div>
                    <div id="coupon-error" v-show="couponCheckError">Le code de réduction n'est pas valide</div>
                    <div id="coupon-valid" v-show="couponIsValid">Le code de réduction est valide</div>
                </div>
            </stripe-element>
        </div>
        <div id="stripe-iban">
          <div class="form-row inline">
            <div class="col">
              <label for="name">Nom</label>
              <input id="name" name="name" placeholder="Votre nom" required="required" v-model="name" />
            </div>
            <div class="col">
              <label for="email">Adresse email</label>
              <input id="email" name="email" type="email" placeholder="Votre email" required="required" v-model="email" />
            </div>
          </div>
          <div id="iban-element"></div>
          <div class="reduc-code" v-if="couponInput">
            <label for="coupon-code">Code de réduction</label>
            <div class="form-field coupon">
              <input id="coupon-code" type="text" v-model="couponCode" name="coupon-code" />
              <button @click="checkCoupon" :class="{'button--is-loading': couponCheckLoading}">Vérifier</button>
            </div>
            <div id="coupon-error" v-show="couponCheckError">Le code de réduction n'est pas valide</div>
            <div id="coupon-valid" v-show="couponIsValid">Le code de réduction est valide</div>
          </div>

        </div>
    </div>

</template>

<script>
    import axios from "axios";
    import {loadStripe} from '@stripe/stripe-js';

    const apiRoute = {
        subscription: "/api/stripe/card/subscription",
        card: "/api/stripe/card/token",
        iban: "/api/stripe/iban/source",
        coupons: "/api/stripe/coupons",
    };

    const STATUS_CANCELED = 'canceled';
    const STATUS_PROCESSING = 'processing';
    const STATUS_REQUIRES_ACTION = 'requires_action';
    const STATUS_REQUIRES_CAPTURE = 'requires_capture';
    const STATUS_REQUIRES_CONFIRMATION = 'requires_confirmation';
    const STATUS_REQUIRES_PAYMENT_METHOD = 'requires_payment_method';
    const STATUS_SUCCEEDED = 'succeeded';

    export default {
        name: 'stripe-payment',
        props: {
            professional: Object,
            address: Object,
            planStripeId: String,
            planName : String,
            couponInput: {
                type:  Boolean,
                default : false
            },
            couponForcedId: {
                type: String,
                default:''
            },
            pricingOptions: Object
        },
        data() {
            return {
                stripeKey : process.env.MIX_STRIPE_PUBLIC_KEY,
                ibanOptions: {
                  supportedCountries: ['SEPA'],
                  placeholderCountry: 'FR',
                },
                prices: [],
                couponCode: '',
                couponChecked: null,
                couponCheckLoading: false,
                couponCheckError: false,
                couponIsValid: false,
                name: this.professional.company,
                email: this.professional.contact_email,
                ibanEl : null,
                stripeInstance: null
            };
        },

        methods: {
            async payByIban(postalCode = null) {
              try {
                this.$emit('load-payment-on');

                let result = await this.stripeInstance.createPaymentMethod({
                  type: 'sepa_debit',
                  sepa_debit: this.ibanEl,
                  billing_details: {
                    name: this.name,
                    email: this.email,
                    address: {
                      line1: this.address.address,
                      postal_code: this.address.zip,
                      city: this.address.city
                    }
                  }
                })

                if (result.error) {
                  this.paymentFailed(result.error.message);
                }

                let subscriptionResponse = await axios.post(apiRoute.iban, {
                  paymentMethodId: result.paymentMethod.id,
                  planStripeId: this.$props.planStripeId,
                  coupon:  (this.couponIsValid ? this.couponChecked.id : this.couponForcedId),
                  postalCode: postalCode,
                }, {
                  'headers': {
                    'Content-Type': 'application/json'
                  }
                });


                window.location.href = '/payment/success/' + subscriptionResponse.data.subscription.id
                this.$emit('load-payment-off');

              } catch (error) {
                console.log(error)
                let errorMsg = 'Erreur: ' + (error.response.data.message || `Une erreur inconnue s'est produite. Contactez-nous pour en savoir plus.`);
                this.paymentFailed(errorMsg);
                document.getElementById('validate-stripe-payment').disabled = false;
              }
            },
            async payByCard() {
                try {
                    this.$emit('load-payment-on');

                    let result = await this.$refs.stripeElementCard.elements.createToken()

                    if (result.error) {
                        this.paymentFailed(result.error.message);
                    }

                    let subscriptionResponse = await axios.post(apiRoute.card, {
                        token: result.token.id,
                        planStripeId: this.$props.planStripeId,
                        coupon:  (this.couponIsValid ? this.couponChecked.id : this.couponForcedId),
                    }, {
                            'headers': {
                                'Content-Type': 'application/json'
                            }
                    });

                    if (!subscriptionResponse.data.paid) {
                        let stripe = await loadStripe(this.stripeKey);
                        let confirmPaymentResponse = await stripe.confirmCardPayment(subscriptionResponse.data.paymentIntent.client_secret);

                        if(confirmPaymentResponse.paymentIntent.status === STATUS_SUCCEEDED) {
                            window.location.href = '/payment/success/' + subscriptionResponse.data.subscription.id
                            this.$emit('load-payment-off');
                        }
                        else
                            throw(confirmPaymentResponse);
                    } else {
                        window.location.href = '/payment/success/' + subscriptionResponse.data.subscription.id
                        this.$emit('load-payment-off');
                    }

                } catch (response) {
                    let errorMsg = 'Erreur: ' + (response.error && response.error.message || `Une erreur inconnue s'est produite. Contactez-nous pour en savoir plus.`)
                    this.paymentFailed(errorMsg);
                }
            },
            async checkCoupon() {
                if (!this.couponCode) {
                    this.couponCheckError = false
                    this.couponChecked = null

                    return
                }

                try {
                    this.couponCheckError = false
                    this.couponCheckLoading = true

                    let response = await axios.post(apiRoute.coupons, {
                        planStripeId: this.$props.planStripeId,
                        coupon: this.couponCode.trim()
                    }, {
                        'headers': {
                            'Content-Type': 'application/json',
                        }
                    })

                    this.couponChecked = response.data.coupon
                    this.couponIsValid = response.data.coupon.valid
                    this.couponCheckLoading = false

                    if (this.couponIsValid) {
                      this.pricingOptions.discounted = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(response.data.discounted_amount / 100) + ' HT /mois'
                      if (response.data.coupon.duration === 'forever') {
                        this.pricingOptions.duration = ''
                      }
                    }

                } catch (error) {
                    this.couponChecked = null
                    this.couponCheckError = true
                    this.couponCheckLoading = false
                }
            },
            paymentFailed(errorMessage) {
                window.location.href = '/payment/failed?plan='+this.planName+'&msg='+errorMessage;
                this.$emit('load-payment-off');
            }
        },
        watch: {
            couponChecked (newValue) {
                document.querySelector(".reduc-code").innerHTML = newValue
                    ? (newValue.percent_off
                        ? 'Code appliqué : ' + newValue.name + ' (' + newValue.percent_off + ' % de réduction)'
                        : 'Code appliqué : ' + newValue.name + ' (' + new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(newValue.amount_off / 100) + ' de réduction')
                    : ''
            },
        },
        async mounted () {
          this.stripeInstance = await loadStripe(this.stripeKey);
          this.ibanEl = this.stripeInstance.elements().create('iban', this.ibanOptions);
          this.ibanEl.mount('#iban-element');
        },
    }
</script>



// WEBPACK FOOTER //
// application/assets/js/professional/containers/Subscriptions/StripePayment.vue